import { ReactElement } from 'react';

import { useShouldShowWaveform } from './hooks';

type Props = {
  children: ReactElement;
};

export const NewWaveformWrapper = (props: Props): ReactElement | null => {
  const newExperience = useShouldShowWaveform();

  if (newExperience) {
    return props.children;
  }

  return null;
};

export const OldWaveformWrapper = (props: Props): ReactElement | null => {
  const newExperience = useShouldShowWaveform();

  if (!newExperience) {
    return props.children;
  }

  return null;
};
